import React, { FC } from 'react';

import { INFAccordionHeaderTitle } from './model';

const NFAccordionHeaderTitle: FC<INFAccordionHeaderTitle> = ({ title, classes }) => (
  <span className={classes}>{title}</span>
);

export default NFAccordionHeaderTitle;
